<template>
    <router-link to="/tryout-members" tag="li"
        ><a
            ><i class="fa fa-user"></i><span>Tryout Members</span></a
        ></router-link
    >
</template>

<script>
export default {
    name: "tryout-members-nav",

    components: {},

    data: function () {
        return { items: [] };
    },

    mounted: function () {},
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?565db3ed